import React, { useState } from 'react';
import { CreditCard, FileText } from 'lucide-react';
import FacturationList from './FacturationList';
import ProformaList from './ProformaList';

type TabType = 'factures' | 'proformas';

const FacturationModule: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('factures');

  const tabs = [
    {
      id: 'factures' as TabType,
      name: 'Factures',
      icon: CreditCard,
      description: 'Factures définitives',
    },
    {
      id: 'proformas' as TabType,
      name: 'Pro Forma',
      icon: FileText,
      description: 'Devis et estimations',
    },
  ];

  return (
    <div className="space-y-5">
      {/* Tabs */}
      <div className="son-tabs" role="tablist">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            role="tab"
            aria-selected={activeTab === tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`son-tab ${activeTab === tab.id ? 'active' : ''}`}
            title={tab.description}
          >
            <tab.icon className="h-4 w-4" aria-hidden />
            <span>{tab.name}</span>
            {tab.id === 'proformas' && (
              <span className="son-chip son-chip-amber !text-[10.5px] !py-0">Devis</span>
            )}
          </button>
        ))}
      </div>

      {/* Content */}
      <div>
        {activeTab === 'factures' && <FacturationList />}
        {activeTab === 'proformas' && <ProformaList />}
      </div>
    </div>
  );
};

export default FacturationModule;
